import { useAlert } from 'dashboard/composables';
import {
  SIGNUP_EVENTS,
  parseSignupEvent,
  isMetaReportedError,
  isUnexpectedFinishEvent,
  reportSignupEvent,
} from 'dashboard/helper/whatsappEmbeddedSignup';

export const SIGNUP_CALLBACK_DELAY_MS = 1000;

export default {
  data() {
    return {
      phoneNumberId: '',
      WABAId: '',
      businessId: '',
      hasCoexistance: false,
      signupFinishedWithoutPhone: false,
      signupErrorReported: false,
      lastSignupEvent: '',
      pendingGenericAlert: null,
    };
  },
  beforeDestroy() {
    this.cancelGenericSignupAlert();
  },
  methods: {
    resetSignupAttempt() {
      this.phoneNumberId = '';
      this.WABAId = '';
      this.businessId = '';
      this.hasCoexistance = false;
      this.signupFinishedWithoutPhone = false;
      this.signupErrorReported = false;
      this.lastSignupEvent = '';
      this.cancelGenericSignupAlert();
    },
    cancelGenericSignupAlert() {
      if (this.pendingGenericAlert) clearTimeout(this.pendingGenericAlert);
      this.pendingGenericAlert = null;
    },
    scheduleGenericSignupAlert(message) {
      this.cancelGenericSignupAlert();
      this.pendingGenericAlert = setTimeout(() => {
        this.pendingGenericAlert = null;
        if (this.signupErrorReported) return;
        useAlert(message);
      }, SIGNUP_CALLBACK_DELAY_MS);
    },
    handleWhatsappEvents(messageEvent) {
      const parsed = parseSignupEvent(messageEvent);
      if (!parsed) return;
      this.lastSignupEvent = parsed.event;

      if (isMetaReportedError(parsed)) {
        this.signupErrorReported = true;
        this.cancelGenericSignupAlert();
        reportSignupEvent(
          'whatsapp_embedded_signup_error',
          parsed,
          this.signupScreen
        );
        useAlert(
          parsed.errorMessage ||
            this.$t('INBOX_MGMT.WHATSAPP_SIGNUP.META_ERROR')
        );
        return;
      }

      if (isUnexpectedFinishEvent(parsed)) {
        reportSignupEvent(
          'whatsapp_embedded_signup_unexpected_event',
          parsed,
          this.signupScreen
        );
      }
      if (parsed.event === SIGNUP_EVENTS.FINISH_ONLY_WABA) {
        this.signupFinishedWithoutPhone = true;
      }
      if (parsed.isCoexistence) this.hasCoexistance = true;
      if (parsed.phoneNumberId) this.phoneNumberId = parsed.phoneNumberId;
      if (parsed.wabaId) this.WABAId = parsed.wabaId;
      if (parsed.businessId) this.businessId = parsed.businessId;
    },
    guardSignupData() {
      if (this.signupFinishedWithoutPhone) {
        useAlert(this.$t('INBOX_MGMT.WHATSAPP_SIGNUP.NO_PHONE_NUMBER'));
        return false;
      }
      if (!this.WABAId) {
        reportSignupEvent(
          'whatsapp_embedded_signup_missing_waba_id',
          { event: this.lastSignupEvent },
          this.signupScreen
        );
        useAlert(this.$t('INBOX_MGMT.WHATSAPP_SIGNUP.MISSING_DATA'));
        return false;
      }
      return true;
    },
  },
};
